import { EntityId } from "@reduxjs/toolkit";
import { DossierPriority } from "./DossierPriority";
import { DossierCapabilityName } from "./DossierCapabilityName";

export interface PatchDossierInformationRequest {
    // nominal typing: https://github.com/Microsoft/TypeScript/blob/7b48a182c05ea4dea81bab73ecbbe9e013a79e99/src/compiler/types.ts#L693-L698
    _patchDossierInformationRequestBrand: never;

    id: EntityId;
    name?: string;
    priority?: DossierPriority;
    externalReference?: string;
    startTime?: string;
    endTime?: string;
    selectedDossierDeviceIds: EntityId[];
    dossierCapabilityNames: DossierCapabilityName[];
}

export function isPatchDossierInformationRequest(
    x: unknown,
): x is PatchDossierInformationRequest {
    return (
        (x as PatchDossierInformationRequest)
            ._patchDossierInformationRequestBrand !== undefined
    );
}
